// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"_2Zm0S5Zw","messageSuccess":"uS3Lm3Us","messageError":"_2iMe83jz","messageInprogress":"_3XXT3x9z"};